<template>
  <div id="adset-ads" class="adset-ad-navbar">
    <vue-tabs ref="adTabsContainer">
      <v-tab v-for="(ad, index) in value" :key="'adset-ad-' + index" :tabKey="'adset-ad-' + index" :hasError="value[index].hasError">
        <!-- Start title -->
        <div slot="title" >
            <img alt="ad-has-error" class="error-ad" v-if="ad.acceptance_status === $constants.AD_ACCEPTANCE_STATUSES.REJECTED && ad.id > 0" src="@/assets/images/ads-recommendition.svg"/>
          <!-- <vs-icon
            v-if="ad.acceptance_status === $constants.AD_ACCEPTANCE_STATUSES.REJECTED && ad.id > 0"
            class="ad-header-icon"
            icon-pack="speakol"
            icon="speakol-cancel"
            color="#ec0000"
          ></vs-icon> -->
          <span class="align-middle pl-3 adset-title">
            {{ 'Ad ' + (index + 1) }}
          </span>

          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer align-middle pl-3 mt-1">
            <vs-icon icon-pack="speakol" icon="speakol-dots" class="adset-icon"/>
            <vs-dropdown-menu class="vx-navbar-dropdown">
              <ul style="min-width: 9rem;">
                <li id="create-campaign-s5-duplicate-button" v-if="value.length < 4" class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 hover:text-black" @click="duplicateAd(index)">
                  <vs-icon class="duplicate-adset-icon" icon-pack="speakol" icon="speakol-duplicate"></vs-icon>
                  <span class="ad-actions ml-2">{{ $t("Duplicate Ad") }}</span>
                </li>
                <li id="create-campaign-s5-remove-button" v-if="value.length > 1 && value[index].id === 0" class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 hover:text-black" @click="removeAd(index, 'confirm')">
                  <vs-icon icon-pack="speakol" icon="speakol-remove" svgClasses="w-5 h-5" style="color: #e02020;"/>
                  <span class="ad-actions ml-2">{{ $t("Remove Ad") }}</span>
                </li>
                <li v-if="!(value.length < 4) && !(value.length > 1 && value[index].id === 0)" class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 hover:text-black">
                  <vs-icon icon-pack="speakol" icon="speakol-alert-circle" svgClasses="w-5 h-5"/>
                  <span class="ml-2">{{ $t("No Actions") }}</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- End title -->

        <!-- Start content -->
        <div class="mt-2">
          <AdContent
            v-model="value[index]"
            v-show="!value[index].is_previewing"
            :adsetIndex="adsetIndex"
            :adIndex="index"
            :serverErrors="serverErrors"
            :advertising-channel="advertisingChannel"
            :objective="objective"
            :objective-id="objectiveId"
            :type="type"
            :editing="editing && value[index].id > 0"
            :adset="adset"
          />
          <AdPreview v-model="value[index]" v-if="value[index].is_previewing" :type="type" :language="language" />
        </div>
        <!-- End content -->

        <vs-popup class="holamundo" :title="$t('Confirmation')" :active="remoableAdIndex === index">
          <p class="mb-10">{{ $t('Are you sure you want to remove') }} {{ `“${ad.name}”` }} ?</p>
          <div class="text-right">
            <vs-button id="create-campaign-s5-remove-ad-popup-close-button" class="mr-4" color="rgb(200, 200, 200)" textColor="#000" type="filled" @click="removeAd(index, 'cancel')">
              {{ $t('Close') }}
            </vs-button>

            <vs-button id="create-campaign-s5-remove-ad-popoup-confirm-button" color="primary" type="filled" @click="removeAd(index, 'remove')">
              {{ $t('Confirm') }}
            </vs-button>
          </div>
        </vs-popup>
      </v-tab>

      <v-tab :disabled="value.length === 4" :isTab="false">
        <div class="add-ad-button" @click="addAd()" slot="title">
          <span class="align-middle">
            <vs-icon class="ad-adset-icon" :class="{'text-gray-500': value.length === 4}" icon-pack="speakol" icon="speakol-add"></vs-icon>
          </span>
          <span id="create-campaign-s5-add-ad-button" class="hide-in-mobile align-middle" :class="{'text-gray-500': value.length === 4}">
            {{ $t("Add New Ad") }}
          </span>
        </div>
      </v-tab>
    </vue-tabs>
  </div>
</template>

<script>
//local registration
import {
  VueTabs,
  VTab
} from '@/components/vue-nav-tabs/vue-nav-tabs.js'

import '@/components/vue-nav-tabs/nav-tabs.scss'

import AdContent from './components/AdContent.vue'
import AdPreview from './components/AdPreview.vue'
import {cloneDeep} from 'lodash'

export default {
  props: {
    value: {
      required: true,
      type: Array
    },
    adsetIndex: {
      required: true,
      type: Number
    },
    serverErrors: {
      required: true
    },
    language: {
      type: String,
      required: true
    },
    advertisingChannel: {
      type: Object,
      required: true
    },
    objective: {
      type: String,
      required: true
    },
    objectiveId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    editing: {
      type: Boolean,
      default: false,
      required: false
    },
    adset: {
      type: Object,
      required: true
    }
  },
  components: {
    VueTabs,
    VTab,
    AdContent,
    AdPreview
  },
  watch: {
    value: {
      handler (newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    },
    serverErrors: {
      handler () {
        this.checkAdsErrors()
      },
      deep: true
    }
  },
  data () {
    return {
      remoableAdIndex: null,
      campaignTypes: this.$constants.CAMPAIGN_TYPES_NAMES
    }
  },
  mounted () {
    // if the url param has ?ad=x will activate the tab with id x
    if (this.$route.query.ad || 0) {
      setTimeout(() => {
        const indexToActivate = this.value.findIndex(i => i.id === parseInt(this.$route.query.ad))
        if (indexToActivate > -1) {
          this.$refs.adTabsContainer.findTabAndActivate(`adset-ad-${indexToActivate}`)
        }
      }, 0)
    }
  },
  methods: {
    addAd (ad = null) {
      if (this.value.length >= 4) {
        return
      }

      this.$gtag.event('Step5_AddNewAD')
      if (this.value.length >= 4) {
        return
      }

      if (ad === null) {
        ad = cloneDeep(this.$store.getters['campaign/defaultAdObject'])
        ad.name = `Ad ${  this.value.length + 1}`
      }

      this.value.push(ad)

      const tabsLength = this.value.length

      setTimeout(() => {
        this.$refs.adTabsContainer.findTabAndActivate(`adset-ad-${  tabsLength - 1}`)
      }, 0)
    },
    removeAd (index, actionType) {
      if (actionType === 'confirm') {
        this.remoableAdIndex = index
        return
      }

      if (actionType === 'cancel') {
        this.remoableAdIndex = null
        return
      }

      if (actionType === 'remove') {
        if (this.value.length === 1) {
          return
        }

        this.remoableAdIndex = null

        setTimeout(() => {
          this.value.splice(index, 1)

          this.$refs.adTabsContainer.findTabAndActivate(`adset-ad-${  index  > 0 ? index - 1 : index}`)
        }, 0)
      }
    },
    duplicateAd (index) {
      // if (this.value[index].hasError) {
      //   return
      // }
      this.$gtag.event('Step5_DuplicateAD')
      const cloned = cloneDeep(this.value[index])

      cloned.id = 0
      cloned.name = `Ad ${  this.value.length + 1}`
      cloned.show_audience_suggestions = true

      this.addAd(cloned)
    },
    checkAdsErrors () {
      const errors = []
      const adHasErrors = []

      this.serverErrors.items.forEach(item => {
        errors.push(item.field)
      })

      this.errors.items.forEach(item => {
        errors.push(item.field)
      })

      // add the errors to adsets has errors
      this.value.forEach((ad, index) => {
        errors.forEach(e => {
          if (e.includes(`adsets.${this.adsetIndex}.ads.${index}.`)) {
            this.value[index].hasError = true
            adHasErrors.push(index)
          }
        })
      })

      // remove the errors from ads that dose not has errors
      this.value.forEach((i, index) => {
        if (!adHasErrors.includes(index)) {
          i.hasError = false
        }
      })
    }
  }
}
</script>

<style lang="scss">
  #adset-ads {
    .tabs__link {
      padding-top: 9px !important;
      padding-bottom: 9px !important;
    }

    .add-ad-button {
      width: 130px;
      position: relative;
      top: 3px;
    }

    .ad-header-icon {
      font-size: 11px !important;
      font-weight: bolder;
      position: relative;
      top: 1px;
    }
  }

  .adset-ad-navbar {
    .error-ad {
      width: 11px;
      height: 11px;
      position: relative;
      top: 2px;
    }
  }

  @media (max-width: 576px) {
    .hide-in-mobile {
      display: none !important;
    }

    .ad-actions {
      width: max-content;
    }

    .add-ad-button {
      width: auto !important;
    }
  }
</style>
